import Toggle from "PFComponents/toggle/toggle";
import { NotificationSetting } from "PFTypes";
import { Controller, useFormContext } from "react-hook-form";

type NotificationSettingImportantCellProps = {
  notificationSetting: NotificationSetting;
};

export const NotificationSettingImportantCell = ({
  notificationSetting
}: NotificationSettingImportantCellProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={`${notificationSetting.id}.important`}
      render={({ field: { onChange, value } }) => <Toggle checked={!!value} onChange={onChange} />}
    />
  );
};
